import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";
import SocialLinks from "./SocialLinks";

export default function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      // Ako nismo na glavnoj stranici, navigiraj na glavnu i zatim scrollaj
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setOpen(false);
    }
  };

  return (
    <header className="navbar">
      <div className="container nav-inner">
        <div className="nav-left">
          <Link to="/" className="logo" onClick={() => setOpen(false)} aria-label="TraveLina">
            <img
              src="/images/travelina-logo.png"
              alt="TraveLina – agencija za putovanja"
              className="logo-image"
              width={220}
              height={48}
            />
          </Link>
        </div>
            <nav className={`nav-links ${open ? "open" : ""}`}>
              <button onClick={() => scrollTo("hero")}>{t("nav.home")}</button>
              <Link to="/blog" onClick={() => setOpen(false)}>
                {t("nav.blog")}
              </Link>
              <button onClick={() => scrollTo("destinations")}>
                {t("nav.destinations")}
              </button>
              <Link to="/travelogue" onClick={() => setOpen(false)}>
                {t("nav.travelogue")}
              </Link>
              <button onClick={() => scrollTo("reviews")}>
                {t("nav.reviews")}
              </button>
              <button onClick={() => scrollTo("about")}>{t("nav.about")}</button>
              <button onClick={() => scrollTo("contact")}>
                {t("nav.contact")}
              </button>
              <div className="nav-social-menu">
                <SocialLinks variant="menu" onItemClick={() => setOpen(false)} />
              </div>
            </nav>
        <div className="nav-right">
          <div className="nav-social-toolbar">
            <SocialLinks variant="toolbar" />
          </div>
          <LanguageSwitcher />
          <button
            className="nav-toggle"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${open ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
